import { render, staticRenderFns } from "./accodion-item.vue?vue&type=template&id=817cfeb4&scoped=true&"
import script from "./accodion-item.vue?vue&type=script&lang=js&"
export * from "./accodion-item.vue?vue&type=script&lang=js&"
import style0 from "./accodion-item.vue?vue&type=style&index=0&id=817cfeb4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "817cfeb4",
  null
  
)

export default component.exports